// Module
var code = "<div align=\"center\" id=\"title-bar\" ng-if=\"tbc.settings.showTitle\">{{tbc.settings.title}}</div> ";
// Exports
module.exports = code;